var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpryskiwaczIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.04 50.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.38,
    y: 5.86,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.25,
    y: 8.8,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.25,
    y: 14.66,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.25,
    y: 2.93,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.11,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.11,
    y: 5.86,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.11,
    y: 11.73,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.11,
    y: 17.59,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.38,
    y: 11.73,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.56,23.46H7.02C2.49,29.04,0,35.94,0,43.23v6.81h26.59v-6.81c0-7.29-2.49-14.19-7.02-19.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.86 5.86 5.86 13.8 8.8 16.73 8.8 20.53 17.79 20.53 17.79 17.59 20.72 17.59 20.72 5.86 5.86 5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.84,17.59c-1.91,0-3.52-1.23-4.13-2.93h2.81V5.86h-5.86v8.8c.68,3.34,3.64,5.86,7.18,5.86h1.47v-2.93h-1.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpryskiwaczIcon);
export default __webpack_public_path__ + "static/media/Spryskiwacz_icon.2d5c14d6bedaf7b9f703d25bbbc6a59c.svg";
export { ForwardRef as ReactComponent };